import React, { useEffect, useState } from 'react'
import DefaultSEO from '../components/DefaultSEO'
import { policyService } from '../services/policyService';

const PrivacyPage = () => {
  const [policy, setPolicy] = useState({ title: 'Privacy Policy', content: '' });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPolicy = async () => {
      try {
        const data = await policyService.getPrivacyPolicy();
        setPolicy(data);
      } catch (error) {
        console.error("Error fetching privacy policy:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchPolicy();
  }, []);

  return (
    <>
      <DefaultSEO title="Privacy Policy | ZoyoTrip" description="Learn how ZoyoTrip protects your privacy and personal data." />
      <div className="container py-5" style={{ maxWidth: "900px" }}>
        <h1 className="fw-bolder display-5 mb-5 text-center text-primary" style={{ fontSize: '3rem' }}>
          {policy.title}
        </h1>

        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <div
            className="policy-content text-muted"
            dangerouslySetInnerHTML={{ __html: policy.content }}
          />
        )}
      </div>
    </>
  );
}

export default PrivacyPage;